import FlowSimpleList from '../flows/FlowSimpleList.react';
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import ChannelList from '../channels/ChannelList.react';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import DeleteButton from '../fw/DeleteButton.react';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import * as FeatureFlags from '../../common/util/FeatureFlags';
import * as BrowserPermission from "../BrowserPermission";
import * as Permission from '../../common/util/Permission';
import OkDialog from '../fw/OkDialog.react';
import Link from 'react-router/lib/Link';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import UserRenderer from '../users/UserRenderer.react';
import SafeHTML from '../fw/SafeHTML.react';

import './Organisation.scss';

export const messages = defineMessages({
	deleteTitle: {id: 'deleteConfirmation.title', 'defaultMessage': 'Do you really want to delete?'},
	deleteLastTitle: {id: 'deleteConfirmation.lastTitle', 'defaultMessage': 'Do you really want to delete? This is your last organisation, we will create you new one instantly.'},
	myDativery: {id: 'menu.home2', 'defaultMessage': 'My Organisation'},
	search: {id: 'myDativery.search', 'defaultMessage': 'Search'},
	connectMoreApps: {id: 'myDativery.connect', "defaultMessage": 'Connect more applications'},
	cantDelete: {id: 'organisation.cantDelete2', "defaultMessage": "Organisation is not empty. Delete all flows and then disconnect all applications to empty it."},
});

class OrganisationView extends React.Component {

	typeName = 'organisations';

	static propTypes = {
		intl: PropTypes.object.isRequired,
		relay: PropTypes.object,
		user: PropTypes.object.isRequired,
	};

	static contextTypes = {
		router: PropTypes.object
	};

	constructor(props) {
		super(props);

		this.usedScenariosEl = null;

		this.state = {
			usedScenariosOverflow: false
		};
	}

	onClick = (event) => {
		let parent = this.props.user.organisation;

		let path = urlMapping.getUrl(types['channels'], "create", parent);
		this.context.router.push(path);
	};

	goToScenarios = () => {
		let path = urlMapping.getUrl(types['scenarios'], "list-all");
		this.context.router.push(path);
	}

	onChange = (event) => {
		let lastValue = event.target.value;

		/* wait 250 ms after last change */
		if (this.delayTimeout) {
			clearTimeout(this.delayTimeout);
		}

		this.delayTimeout = setTimeout(() => {
			this.props.relay.setVariables({
				searchName: lastValue
			});
		}, 250);
	};

	showExplanation(data) {
		let metadata = types['channels'];

		if (metadata.canUserCreate() && metadata.canCreate(BrowserPermission.getPermissionObject(), null, this.props.user.organisation.realId)) {
			return (
				<div>
					<div style={{width: '100%', textAlign: 'center', paddingBottom: '1em',  paddingTop: '2em'}}><FormattedMessage
						defaultMessage="You haven't added any App yet. Add the first one and see data from your favorite apps - Helpdesk, CRM, Accounting and many more."
						id="organisation.emptyExplanation"/></div>

					<div className="bottom-corner">
						<button className="btn btn-primary btn-lg" onClick={this.onClick}>
							<FormattedMessage
								defaultMessage="Start adding first App"
								id="organisation.startAddingChannels"/>
						</button>
					</div>
				</div>
			);
		} else {

			return (
				<div>
					<FormattedMessage
						defaultMessage="You haven't added any App yet, so you can't enjoy all the data. Ask administrator to add first one."
						id="organisation.emptyExplanationWithoutPermission"/>
				</div>
			);
		}
	}

	componentDidMount() {
		this.setUsedScenariosOverflow();
		this.resizeListener = this.setUsedScenariosOverflow.bind(this);

		window.addEventListener("resize", this.resizeListener);
	}

	updateDimensions() {
		this.setUsedScenariosOverflow();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resizeListener);
	}

	setUsedScenariosOverflow() {
		let self = this;

		if (this.usedScenariosEl) {
			setTimeout(() => {
				self.setState({
					usedScenariosOverflow: self.usedScenariosEl.offsetHeight < self.usedScenariosEl.lastElementChild.offsetTop
				});
			}, 0);
		}
	}

	renderOrgMenu() {
		let type = types['organisations'];
		let organisation = this.props.user.organisation;

		let canUpdate = organisation && type.canUserUpdate(organisation) && type.canUpdate(BrowserPermission.getPermissionObject(), organisation, organisation.realId);
		let canDelete = organisation && type.canUserDelete(organisation) && type.canDelete(BrowserPermission.getPermissionObject(), organisation, organisation.realId);

		if (!canUpdate && !canDelete || !organisation) {
			return null;
		}

		return (
			<div className="orgMenu">
				<div className="dropdown pull-right">
					<button aria-expanded="true" aria-haspopup="true" className="btn btn-inline dropdown-toggle" data-toggle="dropdown" id="dropdownOrgMenu" type="button">
						<span className="fa-lg glyphicon glyphicon-option-vertical" />
					</button>
					<ul aria-labelledby="dropdownOrgMenu" className="dropdown-menu" role="menu">
						{canUpdate ? (<li className="dropdown-item">
							<Link className="dropdown-item" to={urlMapping.getUrl("organisations", "edit", organisation)}>
								<i className="fa fa-fw fa-pencil" />&nbsp;<FormattedMessage defaultMessage="Edit organisation" id="Organisation.edit" />
							</Link>
						</li>) : null}
						{canDelete ? (<li className="dropdown-item">
							<DeleteButton
								afterDelete={() => {
									window.location = urlMapping.getUrl('organisations', 'list');
								}}
								asLink
								beforeDelete={() => {
									if (organisation && (
										organisation.channels.edges.length > 0 ||
										organisation.flows.edges.length > 0
									)) {
										return OkDialog(this.props.intl, {
											message: this.props.intl.formatMessage(messages.cantDelete),
										}).then(() => {
											return false;
										}).catch((e) => {
											return false;
										});
									}

									return true;
								}}
								className="dropdown-item"
								confirmDialogConfig={{
									message: this.props.user.organisations && this.props.user.organisations.edges && this.props.user.organisations.edges.length > 1 ? this.props.intl.formatMessage(messages.deleteTitle) : this.props.intl.formatMessage(messages.deleteLastTitle)
								}}
								data={organisation}
								deleteFatQuery={Relay.QL `fragment on DeleteOrganisationPayload {
																updatedNode {
																	id
																},
																user {
																	organisations(first: 100) {
																		edges {
																			node {
																				id,
																				realId,
																				name,
																			}
																		}
																	}
																}
															}`}
								deleteMutation={Relay.QL `mutation { deleteOrganisation }`}
								metadata={type}
								title={<FormattedMessage defaultMessage="Delete organisation" id="Organisation.delete" />}
								types={types}
								urlMapping={urlMapping}
							/>
						</li>) : null}

						<li className="dropdown-item" key="2">
							<Link className="dropdown-item" to={urlMapping.getUrl(types['channelErrors'], 'list-org-fail', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Errors" id="channelErrors.list" /></Link>
						</li>

						{BrowserPermission.hasOrganisationPermission(Permission.PERM_DEVELOPER, this.props.user.organisation.realId) && BrowserPermission.developerModeEnabled() ? [
								<li className="divider" key="0" role="separator">
								</li>,
								<li className="dropdown-item" key="1">
									<Link className="dropdown-item" to={urlMapping.getUrl(types['fetches'], 'list-org', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="API Requests" id="fetches.list" /></Link>
								</li>,

								<li className="dropdown-item" key="3">
									<Link className="dropdown-item" to={urlMapping.getUrl(types['instances'], 'fetch-stats', {id: this.props.user.organisation.instance_id}) + "?organisation_id=" + this.props.user.organisation.realId}><i className="fa fa-fw fa-line-chart"></i> <FormattedMessage defaultMessage="API statistics" id="InstanceView.fetchStats" /></Link>
								</li>,
								<li className="dropdown-item" key="4">
									<Link className="dropdown-item" to={urlMapping.getUrl(types['flowInvocations'], 'list-org', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Invocation history" id="flow.flowInvocations" /></Link>
								</li>,
								<li className="dropdown-item" key="5">
									<Link className="dropdown-item" to={urlMapping.getUrl(types['organisationEvents'], 'list-org', this.props.user.organisation)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Events in organisation" id="organisationEvents.list" /></Link>
								</li>,
								<li className="dropdown-item" key="6">
									<Link className="dropdown-item" to={urlMapping.getUrl(types['billingRules'], 'list', this.props.user.organisation)}><i className="fa fa-fw fa-dollar"></i> <FormattedMessage defaultMessage="Billing rules" id="flow.billingRules" /></Link>
								</li>,
								<li className="dropdown-item" key="7">
									<Link className="dropdown-item" to={urlMapping.getUrl(types['organisations'], 'runningJobs', this.props.user.organisation)}><i className="fa fa-fw fa-lock"></i> <FormattedMessage defaultMessage="Running Tasks" id="InstanceView.runningJobs" /></Link>
							</li>,
				]
						: null}
					</ul>
				</div>
			</div>
		);
	}

	render() {
		const data = this.props.user.organisation;
		let myDativery = this.props.intl.formatMessage(messages.myDativery);
		let title = data.name;

		if (data && data.flows && data.flows.edges && data.flows.edges.length === 0 && data.channels.edges.length === 0) {
			return (
				<AppPanel className="organisationView empty" title={title}>
					{this.renderOrgMenu()}
					<span className="flex"></span>
					<div className="content emptyScreen">
						<img src="/cdn/emptyScreen.svg" width="300" />
						<h2>{myDativery}</h2>
						<span className="description"><FormattedMessage
							defaultMessage="Dativery provides an easy way to integrate applications via scenarios."
							id="organisation.noUsedScenariosExplanation"/></span>
						<div>
							<button className="btn btn-primary btn-lg start" onClick={this.goToScenarios}>
								<FormattedMessage defaultMessage="Find Integration Scenarios" id="organisation.startScenario" />
								&nbsp;<svg className="icon-text" focusable="false" height="12px" version="1.1" viewBox="0 0 8 12" width="8px" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd" id="Symbols" stroke="none" strokeWidth="1"><g fill="#FFFFFF" id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)"><polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38"></polygon></g></g></svg>
							</button>
						</div>
					</div>
					<span className="flex"></span>
				</AppPanel>
			);
		}

		return (
			<AppPanel className="organisationView" title={title}>
				{/*<div className="btn-toolbar hidden-xs" role="toolbar" style={{float: 'right', marginTop: '-3px'}}>
					<div className="input-group" style={{maxWidth: '180px'}}>
						<input className="form-control" name="search" onChange={this.onChange} placeholder={this.props.intl.formatMessage(messages.search)} type="text" />
						<span className="input-group-addon" id="basic-addon2"><span className="fa fa-search"/></span>
					</div>
				</div>*/}

				{this.renderOrgMenu()}
				<h2 className="title-underline">{title ? title : <FormattedMessage defaultMessage="My Organisation" id="menu.home2" />}</h2>
				{BrowserPermission.hasOrganisationPermission(Permission.PERM_INSTANCE_SUPPORT, this.props.user.organisation.realId) && BrowserPermission.developerModeEnabled() && this.props.user.organisation.consultant
					? <div style={{"height": "40px"}}><div style={{"float": "right", "height": "40px"}}><UserRenderer user={this.props.user.organisation.consultant} /></div><br clear="all"/></div>
					: null
				}

				{!data ? <p className="organisationMissing"><FormattedMessage defaultMessage="Organisation has been deleted or you do not have permission to access it." id="organisation.noPermission" /></p> : null}


				{data.blocked ? <div className="channelError">
					<div className="alert alert-danger" role="alert">
						<div className="glyphicon glyphicon-exclamation-sign"></div>
						<div>
								<div>
									<h3><FormattedMessage defaultMessage="Organisation has been blocked" id="organisation.orgHasBeenBlocked" /></h3>
									{data.blockedReason ? <span><FormattedMessage defaultMessage="Reason: " id="organisation.reason" /> <strong>{data.blockedReason}</strong></span> : ""}
								</div>
						</div>
					</div>
				</div> : null}

				{BrowserPermission.hasOrganisationPermission(Permission.PERM_INSTANCE_SUPPORT, this.props.user.organisation.realId) && BrowserPermission.developerModeEnabled() && (this.props.user.organisation.implementationDetails || this.props.user.organisation.implementationDetailsLink) ?
					<div>
						<h4><FormattedMessage defaultMessage="Implementation Details:" id="organisation.implementationDetails" /></h4>
						{this.props.user.organisation.implementationDetails ? <div><SafeHTML value={this.props.user.organisation.implementationDetails} /></div> : null}
						{this.props.user.organisation.implementationDetailsLink ? <a href={this.props.user.organisation.implementationDetailsLink}>{this.props.user.organisation.implementationDetailsLink}</a> : null}
					</div>
				: null}

				{data && data.flows.edges.length > 0 ? <div>
					<FlowSimpleList organisation={data} />
				</div> : null}

				{data && data.channels.edges.length > 0
					?
					<div className="connectedApplications">
						<ChannelList asRow={false} organisation={data}/>
					</div>
					:
					null
				}

				<div className="center findIntegrationsButton">
					<button className="btn btn-primary btn-lg start" onClick={this.goToScenarios}>
						<FormattedMessage defaultMessage="Find Integration Scenarios" id="organisation.startScenario" />
						&nbsp;<svg className="icon-text" focusable="false" height="12px" version="1.1" viewBox="0 0 8 12" width="8px" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd" id="Symbols" stroke="none" strokeWidth="1"><g fill="#FFFFFF" id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)"><polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38"></polygon></g></g></svg>
					</button>
				</div>

			</AppPanel>
		);
	}
}

export default Relay.createContainer(wrapNotFound(injectIntl(OrganisationView), (props) => {
	return props.user.organisation;
}), {
	initialVariables: {
		organisationId: '',
		searchName: '',
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				featureFlags,
				organisation(id: $organisationId) {
					id,
					realId,
					instance_id,
					name,
					description,
					featureFlags,
					implementationDetails,
					implementationDetailsLink,
					blocked,
					blockedReason,
					consultant {
						id,
						realId,
						name,
						firstname, 
						surname, 
						email,
						picture
					},
					channels(first: 200, deleted: false) {
						edges {
							node {
								id
							}
						}
					},
					flows(first: 200, deleted: false) {
						edges {
							node {
								id
							}
						}
					}
					${FlowSimpleList.getFragment('organisation')},
					usedScenarios(first: 100) {
						edges {
							node {
								id,
								realId,
								scenario, {
									id,
									realId,
									title,
									${ScenarioBox.getFragment('scenario')}
								}
							}
						}
					},
					${ChannelList.getFragment('organisation')},
					relevantScenarios(first: 8, nameLike: $searchName) {
						edges {
							node {
								id,
								realId,
								${ScenarioBox.getFragment('scenario')}
							}
						},
						pageInfo {
							hasNextPage,
							hasPreviousPage,
							startCursor,
							endCursor
						}
					}
				}
				organisations(first: 10000) {
                    edges {
                        node {
		                    realId,
                        }
                    }
                }
			}
		`,
	},
});
